import React from 'react';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';

import ResponsiveBox from 'components/generic/ResponsiveBox.component';
import LINK from 'constants/link.const';
import S from 'constants/string.const';
import { useTranslation } from 'providers/GILT.provider';
import { useCurrentSalonId } from 'providers/SalonBasicInfo.provider';
import { useTheme } from 'providers/Theme.provider';
import linkTo from 'utils/links/linkTo.util';

import CN from './NoStylistDataPreview.module.scss';

const NoStylistDataPreview = () => {
  const { isDarkMode } = useTheme();
  const salonId = useCurrentSalonId();
  const { t } = useTranslation();

  return (
    <div
      data-bem="NoStylistDataPreview"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <div className={CN.titleMessage}>
        {t('staffKpisReports.kpiReports.noStylistData.title', { face: S.faceWithTear })}
      </div>
      <div className={CN.message}>{t('staffKpisReports.kpiReports.noStylistData.description1')}</div>
      <div className={CN.message}>
        {t('staffKpisReports.kpiReports.noStylistData.description2Part1')}
        <NavLink to={linkTo({ pattern: LINK.hrEditKpi, params: { salonId } })}>
          <span className={CN.highlighted}>
            <ResponsiveBox.Desktop> {t('staffKpisReports.kpiReports.noStylistData.link1')}</ResponsiveBox.Desktop>
            <ResponsiveBox.Mobile> {t('staffKpisReports.kpiReports.noStylistData.link2')}</ResponsiveBox.Mobile>
          </span>
        </NavLink>
        {t('staffKpisReports.kpiReports.noStylistData.description2Part2')}
      </div>
    </div>
  );
};

export default NoStylistDataPreview;
